import { media } from '@sizeid/commons/utils/styles';

export const jumbotron = `
  min-height: 100px;

  ${media.moreThan('sm')`
    min-height: 0;
  `};

  ${media.moreThan('md')`
    min-height: 150px;
  `};
`;
